<script>
/**
 * 带校验的输入组件，支持 input，select等支持change函数和value属性的组件
 * @author lvxin08
 */
import Validator from 'async-validator';

export default {
    name: 'XxValidateInput',
    inject: ['registerValidInput', 'unloadValidInput'],
    props: {
        /**
         * 校验规则
         * 参考文档：<a href="https://github.com/yiminghe/async-validator" target="_blank">async-validator</a>
         */
        rules: {
            type: Array,
            default: () => []
        },
        /**
         * 组件的值
         */
        value: {
            type: [String, Number, Boolean, Object, Array],
            required: false,
            default: ''
        },
        /**
         * 其他数据，会作为校验回调函数的参数 （例如： table 的 row 对象）
         * @default {Object}
         */
        source: {
            type: Object,
            default: () => ({})
        },
        /**
         * 输入组件的类型
         */
        type: {
            type: String,
            default: 'el-input'
        },
        /**
         * input的值挂载到source中的key ，不传则自动生成Symbol
         */
        prop: {
            type: String,
            default: 'inputVal'
        },
        /**
         * 是否在值改变的时候自动进行校验
         */
        autoValidate: {
            type: Boolean,
            default: false
        },
        /**
         * 值改变校验时，是否提示错误（ 以$message.error('msg') 的方式提示）
         */
        showMessage: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            key: this.prop || Symbol('validate-input-key'),
            validator: null,
            val: this.value || '',
            isError: false
        };
    },
    watch: {
        value(v) {
            this.val = v;
            this.autoValidate && this.validate();
        }
    },
    created() {
        this.validator = new Validator({ [this.key]: this.rules });
        if (typeof this.registerValidInput === 'function') {
            // 如果组件被植入table-pro，则注册组件
            this.registerValidInput(this);
        }
    },
    beforeDestroy() {
        if (typeof this.unloadValidInput === 'function') {
            // 如果组件被植入table-pro，则在销毁前注销组件
            this.unloadValidInput(this);
        }
    },
    methods: {
        async change(v, ...args) {
            const errors = await this.validate(this.showMessage);
            errors && this.$emit('error', errors);
            this.input(v);
            this.$emit('change', v, this.source, ...args);
        },
        input(v) {
            this.$emit('input', (this.val = v));
        },
        validate(showMessage = false) {
            return new Promise(resolve => {
                this.validator.validate(Object.assign(this.source, { [this.key]: this.val }), errors => {
                    this.isError = !!errors;
                    if (errors && showMessage) {
                        this.$message.error({
                            dangerouslyUseHTMLString: true,
                            message: errors.map(e => e.message).join('<br />')
                        });
                    }
                    resolve(errors);
                });
            });
        }
    },
    render(create) {
        return create(
            'div',
            {
                class: {
                    'el-form-item': this.isError,
                    'is-error': this.isError
                },
                style: {
                    marginBottom: 0,
                    display: 'inline-block'
                }
            },
            [
                create(
                    this.type,
                    {
                        attrs: {
                            ...this.$attrs,
                            size: this.$attrs.size || 'small',
                            value: this.val,
                            'v-model': this.val
                        },
                        on: {
                            ...this.$listeners,
                            input: this.input,
                            change: this.change
                        }
                    },
                    this.$slots.default
                )
            ]
        );
    }
};
</script>
